import { Component } from 'react';
import { connect } from 'react-redux';
import { sendUserDebug } from 'services/users/duck';
import Mousetrap from 'mousetrap';

class KeyCatcherContainer extends Component {
    componentDidMount() {
        Mousetrap.bind('@ d e b u g', () => {
            this.props.sendUserDebug(this.props.currentUser);
        });
    }

    componentWillUnmount() {
        Mousetrap.unbind('@ d e b u g');
    }

    render() {
        return (null);
    }
}

const mapStateToProps = state => ({
    currentUser: state.users.currentUser
});

export default connect(mapStateToProps, { sendUserDebug })(KeyCatcherContainer);



// WEBPACK FOOTER //
// ./src/containers/KeyCatcherContainer.js